import React, { useState } from 'react';

// hooks
import { useHistory } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { useConfigContext } from '../../../Config/hooks/useConfig';
import useFilters from '../../../../hooks/useFilters';

// constants
import { QueryKeys } from '../../../../queryKeys';
import { USER_ACTIONS, CUSTOMER } from '../../../../constraints';
import appRoutes from '../../../../app-routes';

// Components
import { FormattedMessage } from 'react-intl';
import UsersTable from '../../components/UsersTable';
import CreateForm from '../../components/CreateForm';
import { SuccessModal as CustomSuccessModal } from '../../../../components/SuccessModal';
import { Layout as LayoutModule, Modal as ModalModule } from 'billon-ui';

const { Content: ContentModule } = LayoutModule;
const { ContentContainer } = ContentModule;
const { CreateModal } = ModalModule;

const HomePage = () => {
  const history = useHistory();
  const queryClient = useQueryClient();
  const { filters } = useFilters();
  const { customer, config } = useConfigContext();
  const { enablePrivate } = config;

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({});

  const handleSuccess = (data) => {
    setCreateModalOpen(false);
    if (customer === CUSTOMER.TAURON && data?.id) {
      history.push(appRoutes.TEMPORATY_PASSWORD_SET.replace(':id', data.id));
    } else {
      setSuccessModalOpen(true);
    }
    queryClient.invalidateQueries([QueryKeys.USERS_LIST, filters]);
  };

  const handleFailure = () => {};

  const handleOpenCreateModal = () => {
    setCreateModalOpen(true);
    setInitialValues({});
  };

  const handleCloseCreateModal = () => {
    setCreateModalOpen(false);
  };

  const handleCloseSuccessModal = () => {
    setSuccessModalOpen(false);
  };

  return (
    <ContentContainer fluid>
      <UsersTable handleCreate={handleOpenCreateModal} />
      <CreateModal
        isOpen={createModalOpen}
        onSuccess={handleSuccess}
        onCancel={handleCloseCreateModal}
        initialValues={{
          ...initialValues,
        }}
        editMessage={
          <FormattedMessage
            id="Editing administrator"
            defaultMessage="Editing administrator"
          />
        }
        createMessage={
          <FormattedMessage
            id="Adding administrator"
            defaultMessage="Adding administrator"
          />
        }
      >
        <CreateForm
          mode={USER_ACTIONS.CREATE}
          onSuccess={handleSuccess}
          onFailure={handleFailure}
          enablePrivate={enablePrivate}
          customer={customer}
        />
      </CreateModal>
      <CustomSuccessModal
        isOpen={successModalOpen}
        toggle={handleCloseSuccessModal}
        onClose={handleCloseSuccessModal}
        closeIconEnabled={false}
      >
        <FormattedMessage
          id={'Administrator added successfully'}
          defaultMessage={'Administrator added successfully'}
        />
      </CustomSuccessModal>
    </ContentContainer>
  );
};

export default HomePage;
